import React, { useRef, useState, useEffect } from "react";
import Lottie from "lottie-react";
import arrowAnim from "../animation/ArrowDownBounce.json";
import "../styles/CorporateResponsibility.css";
import Footer from '../component/footer';

const cdnURL = process.env.REACT_APP_CDN_URL;

const images = [
  { id: 1, 
    mainImage: `${cdnURL}/images/corporate/HKHM_PROGRAMME_1-01.jpg`, 
    photos: [`${cdnURL}/images/corporate/HKHM_PROGRAMME_1-02.jpg`,`${cdnURL}/images/corporate/HKHM_PROGRAMME_1-03.jpg`], 
    title:"KEMENTERIAN KOMUNIKASI </br> HKHM PROGRAMME", 
    description: "In celebration of the Hari Kebangsaan Hari Malaysia (HKHM) Programme 2024 organised by the Ministry of Communications, XOX contributed goody bags and essential supplies for all participants to inspire national pride and bring community members together. This initiative reflects our commitment to nurturing community spirit, promoting inclusivity, and celebrating the shared values that unite Malaysians. Through meaningful collaborations with ministries, XOX continues to proudly support government-led efforts to strengthen social connection and national belonging." 
  },
  { id: 2, 
    mainImage: `${cdnURL}/images/corporate/XOX_SUPPORT_COMMUNITIES_1-01.jpg`, 
    photos: [`${cdnURL}/images/corporate/XOX_SUPPORT_COMMUNITIES_1-02.jpg`,`${cdnURL}/images/corporate/XOX_SUPPORT_COMMUNITIES_1-03.jpg`,`${cdnURL}/images/corporate/XOX_SUPPORT_COMMUNITIES_1-04.jpg`,`${cdnURL}/images/corporate/XOX_SUPPORT_COMMUNITIES_1-05.jpg`,`${cdnURL}/images/corporate/XOX_SUPPORT_COMMUNITIES_1-06.jpg`], 
    title:"XOX SUPPORT </br>COMMUNITIES", 
    description:"We believe that kindness connects us all. Through our ongoing #XOXCares initiative, we actively engage with schools, hospitals, and charity homes across Malaysia delivering essential supplies and heartfelt support. We stand alongside communities that need it most, bringing comfort, hope, and smiles. <br/> <br/>Our commitment is more than just a responsibility - it is who we are. As a brand that is built on empathy, unity, and purpose, we strive to create a brighter tomorrow for every Malaysian." 
  },
  { id: 3, 
    mainImage: `${cdnURL}/images/corporate/MERDEKA_FOOD_RUN_2024_1-01.jpg`, 
    photos: [`${cdnURL}/images/corporate/MERDEKA_FOOD_RUN_2024_1-02.jpg` ,`${cdnURL}/images/corporate/MERDEKA_FOOD_RUN_2024_1-03.jpg`], 
    title:"MERDEKA </br>FOOD RUN 2024", 
    description:"In conjunction with Merdeka celebrations, XOX proudly supported the Merdeka Food Run 2024, an event that brought together fitness, fun, and food to celebrate Malaysia’s cultural diversity and vibrant community spirit. Initiatives like this helps us to promote wellness, unity, and inclusivity, encouraging Malaysians to stay active while connecting through a shared sense national pride." 
  },
  { id: 4, 
    mainImage: `${cdnURL}/images/corporate/TAMANNEGARA,KUALATAHAN_1-01.jpg`, 
    photos: [`${cdnURL}/images/corporate/TAMANNEGARA,KUALATAHAN_1-02.jpg`,`${cdnURL}/images/corporate/TAMANNEGARA,KUALATAHAN_1-03.jpg`,`${cdnURL}/images/corporate/TAMANNEGARA,KUALATAHAN_1-04.jpg`,`${cdnURL}/images/corporate/TAMANNEGARA,KUALATAHAN_1-05.jpg`,`${cdnURL}/images/corporate/TAMANNEGARA,KUALATAHAN_1-06.jpg`,`${cdnURL}/images/corporate/TAMANNEGARA,KUALATAHAN_1-07.jpg`,`${cdnURL}/images/corporate/TAMANNEGARA,KUALATAHAN_1-08.jpg`], 
    title:"TAMAN NEGARA,</br>KUALA TAHAN", 
    description:"In Kuala Tahan, Pahang, our team connected with the Orang Asli community, equipping essential supplies and basic telecommunication kits to local children for their learning journey. <br/><br/> We are committed to supporting education for all and uplifting the underprivileged communities. By enabling children with the necessary resources, we aim to inspire hope, build confidence and create equal opportunities – ensuring every child has the tools to carve their own brighter future."
  },
  { id: 5, 
    mainImage: `${cdnURL}/images/corporate/XOX_X_UITM_RUN_FOR_AWARENESS_1-01.jpg`, 
    photos: [`${cdnURL}/images/corporate/XOX_X_UITM_RUN_FOR_AWARENESS_1-02.jpg`, `${cdnURL}/images/corporate/XOX_X_UITM_RUN_FOR_AWARENESS_1-03.jpg`, `${cdnURL}/images/corporate/XOX_X_UITM_RUN_FOR_AWARENESS_1-04.jpg`], 
    title:"XOX X UITM: </br>RUN FOR AWARENESS", 
    description:`In conjunction with Breast Cancer Awareness Month, XOX supported the "Run for the Gold, Fight for the Pink" campaign held at UiTM Shah Alam, organised by the Delima Students’ Committee. The event aimed to raise awareness about breast cancer prevention and early detection, especially among youth. <br/><br/> Through this collaboration, XOX reaffirmed its dedication to promote health education, community wellness, and social responsibility, inspiring Malaysians to take proactive steps toward better well-being.`
  },
  { id: 6, 
    mainImage: `${cdnURL}/images/corporate/WORLD_DEAF_FOOTBALL_CLUB_1-01.jpg`, 
    photos: [`${cdnURL}/images/corporate/WORLD_DEAF_FOOTBALL_CLUB_1-02.jpg`, `${cdnURL}/images/corporate/WORLD_DEAF_FOOTBALL_CLUB_1-03.jpg`,`${cdnURL}/images/corporate/WORLD_DEAF_FOOTBALL_CLUB_1-04.jpg`,`${cdnURL}/images/corporate/WORLD_DEAF_FOOTBALL_CLUB_1-05.jpg`], 
    title:"WORLD DEAF</br> FOOTBALL CLUB", 
    description:"We believe in the power of sports to unite and empower communities. By supporting the World Deaf Football Club Malaysia, we help differently-abled athletes showcase their talent, perseverance, and passion, ensuring equal opportunities both on and off the pitch. Through initiatives like this, XOX strives to build a more inclusive and connected Malaysian community where everyone has a voice and a platform to shine." 
  }
];

const CorporateResponsibility = () => {

    const [activeIndex, setActiveIndex] = useState(null);
    const activeImage = images.find(img => img.id === activeIndex);
    const popupImages = activeImage ? [(activeImage.photos || [])] : [];
    const [currentSlide, setCurrentSlide] = useState(0);
    const closeModal = () => setActiveIndex(null);
    const half = Math.ceil(images.length / 2);
    const topImages = images.slice(0, half);
    const bottomImages = images.slice(half);

    const nextSlide = () => setCurrentSlide((prev) => activeImage.photos && activeImage.photos.length > 0 ? (prev + 1) % activeImage.photos.length : 0  );
    const prevSlide = () => setCurrentSlide((prev) => activeImage.photos && activeImage.photos.length > 0 ? (prev - 1 + activeImage.photos.length) % activeImage.photos.length : 0 );

    useEffect(() => {
        if (activeImage) setCurrentSlide(0);
    }, [activeImage]);


    return (
        <div className="corporate_page">

            <div className="corporate_banner">
                <div className="corporate_title">
                    <h1>We Care Beyond</h1>
                    <p>At XOX, we focus on impact, not just business. <br/><br/> We champion sustainability, community empowerment, and ethical progress,<br/> ensuring technology creates meaningful change for both people and the planet. </p>
                </div>

                <img src={`${cdnURL}/images/corporate/banner_CSR.png`}/>
            </div>

            <div className="corporate_content">
                <div className="slider-wrapper">
                    {/* Top row */}
                    <div className="slider-row top">
                        <div className="slider-track">
                        {[...topImages, ...topImages].map((img, i) => (
                            <div key={`${img.id}-${i}`} className="slide" onClick={() => setActiveIndex(img.id)}>
                                {/* <a dangerouslySetInnerHTML={{ __html: img.title }} /> */}
                                <img src={img.mainImage} alt={img.alt} />
                            </div>
                        ))}
                        </div>
                    </div>

                    {/* Bottom row */}
                    <div className="slider-row bottom">
                        <div className="slider-track">
                        {[...bottomImages, ...bottomImages].map((img, i) => (
                            <div key={`b-${img.id}-${i}`} className="slide" onClick={() => setActiveIndex(img.id)}>
                                {/* <a dangerouslySetInnerHTML={{ __html: img.title }} /> */}
                                <img src={img.mainImage} alt={img.alt} />
                            </div>
                        ))}
                        </div>
                    </div>
                </div>
            </div>

            {activeImage ? (
                <div className="corporate-overlay" onClick={closeModal}>

                    <div className="corporate-box" onClick={(e) => e.stopPropagation()}>
                        <button className="close-btn" onClick={closeModal}>
                            <img src={`${cdnURL}/icon/icon_close.svg`} alt="icon_close"></img> 
                        </button>

                        <div className="corporate-details">

                            <div className="corporate-image-wrapper">
                                <div className="corporate-image-group">
                                    {activeImage.photos.length > 1 && (
                                        <button className="nav-btn3 left" onClick={prevSlide}>
                                            <Lottie animationData={arrowAnim} loop={true} style={{transform: "rotate(90deg)" }} className="arrow-corporate"/>
                                        </button>
                                    )}
                                    <div className="corporate-image">
                                        <img src={activeImage.photos[currentSlide]} alt={`${activeImage.title}-${currentSlide}`} />
                                    </div>
                                    {activeImage.photos.length > 1 && (
                                        <button className="nav-btn3 right" onClick={nextSlide}>
                                            <Lottie animationData={arrowAnim} loop={true} style={{transform: "rotate(-90deg)" }} className="arrow-corporate"/>
                                        </button>
                                    )}
                                </div>

                                {activeImage.photos  && (
                                <div className="dot-indicators">
                                    {activeImage.photos.map((_, idx) => (
                                    <span
                                        key={idx}
                                        className={`dot ${idx === currentSlide ? "active-dot" : ""}`}
                                        onClick={() => setCurrentSlide(idx)}
                                    ></span>
                                    ))}
                                </div>
                                )}

                            </div>

                            <div className="corporate-content">
                                <h2 dangerouslySetInnerHTML={{ __html: activeImage.title }} />
                                <p dangerouslySetInnerHTML={{ __html: activeImage.description }}/>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
            <div style={{padding:"0px 5.208vw", marginTop: "auto"}}>
                <Footer />
            </div>
        </div>
    );
};

export default CorporateResponsibility;